import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '数据元素',
    textProp: 'algTitle',
    type: 'BD_STRUCT',
}
